import type { BinderItemsRequest } from "modules/binder/model/binder";
import { QUERIES } from "modules/common/query";

export function binderListsQueryKey(userId: string) {
  return [QUERIES.TRADE_LISTS_PAGED, { binder: true, userId }] as const;
}

export function binderItemsQueryKey(request: BinderItemsRequest) {
  const prefix =
    request.section === "collection"
      ? QUERIES.COLLECTION_CARDS
      : QUERIES.TRADE_LIST_ITEMS;

  return [prefix, { ...request, binder: true }] as const;
}

export function binderFacetsQueryKey(request: BinderItemsRequest) {
  const prefix =
    request.section === "collection"
      ? QUERIES.COLLECTION_FACETS
      : QUERIES.TRADE_LIST_FACETS;

  return [
    prefix,
    {
      binder: true,
      collectionId: request.collectionId,
      section: request.section,
      listId: request.listId,
      query: request.query,
      facets: request.facets,
    },
  ] as const;
}
